module.exports = __webpack_public_path__ + "static/img/logo.c656a773.png";